import { Col, Form, Input, Modal, Row } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../theme/ThemeContext'
import { message } from 'antd' // 加个提示

const K1 = ['干贴', '湿贴', '热敷', '1日1帖', '1日2帖', '1日3帖', '2日1帖', '3日1帖',]
const K2 = ['每贴30分钟', '每贴1小时', '每贴2小时', '每贴3小时', '每贴4小时', '每贴5小时',]
const K3 = ['每贴6小时', '每贴8小时', '每贴10小时', '每贴12小时', '每贴24小时',]
const K4 = ['涌泉穴', '中脘穴', '大椎穴', '天突穴', '胆中穴',]

export const TFMethodModal = (props?: {
  value?: any,
  visible?: boolean,
  currentGroupIndex?: number,
  onChange: (values: any, index: any,) => void,
  onCancel?: () => void,
}): ReactElement => {
  const inputRef = React.useRef<any>(null)
  const theme = useContext(ThemeContext)
  const [selectedValues, setSelectedValues] = useState<string[]>([])
  const [selected, setSelected] = useState<any>()
  const [form] = Form.useForm()

  useEffect(() => {
    if (props?.visible) {
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100);
      const values = (selectedValues?.length ? selectedValues : props?.value?.groupUsemethod?.split(',') || [])?.filter((v: any) => v != '')
      
      if (values?.length) {
        form.setFieldsValue({
          useMethod: values?.join('，') || values?.join(','),
        })
      }
    }
  }, [selectedValues, props?.visible])

  useEffect(() => {
    if (!props?.visible) {
      setSelectedValues([])
      setSelected(undefined)
      form.resetFields()
    }
  }, [props?.visible])

  // ✅ 核心修复：点击添加时，判断长度是否超限
  const handleAddText = (text: string) => {
    const currentText = form.getFieldValue('useMethod') || ''
    const maxLength = 50

    // 将要拼接的结果
    let newText
    if (currentText) {
      newText = currentText + '，' + text
    } else {
      newText = text
    }

    // 超过最大长度 → 不添加，提示
    if (newText.length > maxLength) {
      return
    }

    // 没超过 → 正常添加
    form.setFieldsValue({ useMethod: newText })
    setSelected(text)
  }

  const row = {
    gutter: 10,
    style: {
      color: theme.tc1,
      fontSize: '1rem',
    },
  }

  const col = {
    style: {
      marginBottom: 10,
      lineHeight: '2rem',
      textAlign: 'center',
      fontSize: '1rem',
    } as React.CSSProperties,
  }

  const firstColumnLayout = {
    labelCol: {
      flex: '0 0 7rem',
    },
  }

  const btn = (selected: boolean) => ({
    style: {
      boxSizing: 'border-box' as const,
      border: selected ? `solid 1px ${theme.c1}` : `solid 1px ${theme.wbd}`,
      borderRadius: 4,
      color: selected ? theme.c1 : theme.tc1,
      cursor: 'pointer',
      padding: '3px 10px',
    },
  })

  return (
    <Modal
      title='处方用法'
      visible={props?.visible}
      width={720}
      onOk={() => {
        props?.onChange(form.getFieldValue('useMethod'), props?.currentGroupIndex)
      }}
      onCancel={() => {
        props?.onCancel && props?.onCancel()
      }}
    >
      <Row {...row}>
        {K1?.map((v) => (
          <Col key={v} {...col}>
            <div {...btn(v === selected)} onClick={() => handleAddText(v)}>
              {v}
            </div>
          </Col>
        ))}
        {K2?.map((v) => (
          <Col key={v} {...col}>
            <div {...btn(v === selected)} onClick={() => handleAddText(v)}>
              {v}
            </div>
          </Col>
        ))}
        {K3?.map((v) => (
          <Col key={v} {...col}>
            <div {...btn(v === selected)} onClick={() => handleAddText(v)}>
              {v}
            </div>
          </Col>
        ))}
        {K4?.map((v) => (
          <Col key={v} {...col}>
            <div {...btn(v === selected)} onClick={() => handleAddText(v)}>
              {v}
            </div>
          </Col>
        ))}
      </Row>

      <Form form={form}>
        <Row wrap={false} align='middle' {...row}>
          <Form.Item label='' name='useMethod' {...firstColumnLayout} noStyle>
            <Input.TextArea
              ref={inputRef}
              maxLength={50}
              showCount
              rows={3}
              style={{ width: '670px', marginTop: '15px' }}
            />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  )
}